import React from 'react';
import PendingGoodReceivingList from './PendingGoodReceivingList';

const PendingGoodReceiving = () => (
  <React.Fragment>
    <div className="org-wrapper">
      <PendingGoodReceivingList />
    </div>
  </React.Fragment>
);

export default PendingGoodReceiving;
